import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { FreshdeskIntegrationForm1 } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm1/FreshdeskIntegrationForm1';
import { FreshdeskIntegrationForm2 } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/FreshdeskIntegrationForm2';
import type { FreshdeskIntegrationType } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/FreshdeskIntegrationForm2';

export const CreateFreshdeskIntegrationPopup = ({
  trigger,
  closeSourceModal = () => {},
  disabled = false,
}: {
  trigger: React.ReactNode;
  closeSourceModal?: () => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [freshdeskIntegrationType, setFreshdeskIntegrationType] =
    useState<FreshdeskIntegrationType>('Tickets');
  const close = (shouldCloseSourceModal = false) => {
    setStep(0);
    setOpen(false);
    shouldCloseSourceModal && closeSourceModal();
  };

  // The first step reports the chosen type; later steps move on without data.
  const nextStep = (data?: { freshdeskIntegrationType?: FreshdeskIntegrationType }) => {
    if (step === 0) {
      setFreshdeskIntegrationType(data.freshdeskIntegrationType);
    }

    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        disabled={disabled}
        asChild
        className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
      >
        {trigger}
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle className={'px-4'}>
            Freshdesk {step !== 0 && freshdeskIntegrationType} Integration
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4">
          <div className="content min-h-[510px]">
            {step === 0 && (
              <FreshdeskIntegrationForm1
                freshdeskIntegrationType={freshdeskIntegrationType}
                nextStep={nextStep}
                closePopup={close}
              />
            )}
            {step === 1 && (
              <FreshdeskIntegrationForm2
                freshdeskIntegrationType={freshdeskIntegrationType}
                prevStep={prevStep}
                closePopup={close}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
